import { CommandRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * commandOnSaveData - Function that saves on database an personalized protocol command  
 * /commands   
 * method POST 
 * @async-function
 */
const commandOnSaveData = async (token: string, model: CommandRequestType) => {
    const response = await api.post(
        `/commands`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default commandOnSaveData;